import React from 'react';
import { useIntl } from 'react-intl';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Core components
import MenuButton from 'components/core/MenuButton';
// Permissions
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mSource from 'models/source';
// Custom
import { sourceDataShape, menuItemsShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const SourceItem = ({
  source, toggle, menuItems, permissions,
}) => {
  const intl = useIntl();

  return (
    <InformationItem
      label={intl.formatMessage({ id: `source.type.${source.type}` })}
      value={source.name}
      icon={mSource.type(source).icon}
      withAvatar
      toggle={toggle}
      rightButton={!_isEmpty(menuItems) ? <OnlyWith permissions={permissions}><MenuButton obj={source} items={menuItems} /></OnlyWith> : null}
    />
  );
};

SourceItem.propTypes = {
  source: sourceDataShape.isRequired,
  toggle: PropTypes.shape({
    toggled: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
  }),
  menuItems: menuItemsShape,
  permissions: PropTypes.string,
};

SourceItem.defaultProps = {
  toggle: null,
  menuItems: null,
  permissions: null,
};

module.exports = SourceItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/SourceItem.js